import StringHelper from '@/app/[lang]/(search)/_components/shared/helper/string.helper';
import { SubscriptionTierTypeConstant } from '@/app/_constant/subscription-tier.constant';
import {
    formatListingType,
    generateListingDepth,
    getChannelName,
    getCityName,
    getDistrictName,
    getLatitude,
    getLocationAddress,
    getLongitude,
    getProvinceName,
    translatePropertyType,
} from '@/app/_helper/property';
import { convertEpochTimeToISOFormat } from '@/app/_helper/time';
import { Property } from '@/modules/core/gql/generated';
import { SubChannelURLEnum } from '@/modules/property/property.type';

const generatePayloadProperty = (property: Property) => {
    const { agent } = property;

    const agentSubscription = agent?.subscription;

    const agentSubscriptionStartDate =
        agentSubscription && agentSubscription.time
            ? convertEpochTimeToISOFormat(agentSubscription.time.created)
            : '';

    const agentSubscriptionEndDate =
        agentSubscription &&
        agentSubscription.time &&
        agentSubscription.time.expire
            ? convertEpochTimeToISOFormat(agentSubscription.time.expire)
            : '';

    const channel = getChannelName(
        property?.priceType ? Number(property?.priceType?.value) : 0,
        property?.primaryProject?.isPrimary || false,
        property?.url || '',
    );

    const agencyName = agent?.organization ? agent.organization.name : '';
    const agencyId = agent?.organization ? agent.organization.originId : '';
    const agentId = agent?.originId || '';
    const agentName = agent?.name;

    const type = translatePropertyType(
        property?.primaryProject?.isPrimary || false,
        property?.propertyType,
        property?.primaryProject,
    );

    let parentId = '';
    if (property.primaryProject && property.primaryProject.parent) {
        parentId = property.primaryProject.parent.originId;
    }

    const defaultTracker = {
        agent_subscription_end: agentSubscriptionEndDate,
        agent_subscription_start: agentSubscriptionStartDate,
        agent_subscription_type: agentSubscription
            ? SubscriptionTierTypeConstant[
                  agentSubscription ? agentSubscription.subscriptionTierId : 0
              ]
            : undefined,
        built_size: property?.attributes?.buildingSize?.value
            ? Number(property?.attributes?.buildingSize?.value)
            : 0,
        company: {
            id: channel === 'new' ? agentId : agencyId,
            name: channel === 'new' ? agentName : agencyName,
        },
        land_size:
            type &&
            (type.toLocaleLowerCase().includes('rumah') ||
                type.toLocaleLowerCase().includes('tanah'))
                ? Number(property?.attributes?.landSize?.value)
                : null,
        latlng: {
            latitude: getLatitude(property?.locationPin),
            longitude: getLongitude(property?.locationPin),
        },
        listing_created_date: convertEpochTimeToISOFormat(
            property?.time?.created,
        ),
        listing_depth: generateListingDepth(
            channel,
            agentSubscription ? agentSubscription.subscriptionTierId : 0,
        ),
        listing_expiry_date: convertEpochTimeToISOFormat(property?.time?.expire || 0),
        listing_id: property.originId?.formattedValue,
        listing_name: property.title,
        listing_type: channel,
        location_city: StringHelper.capitalizeFirstLetter(
            getCityName(property.location).replace('-', ' '),
        ),
        location_district: StringHelper.capitalizeFirstLetter(
            getDistrictName(property.location).replace('-', ' '),
        ),
        location_full_address: getLocationAddress(property.location) || '',
        location_province: StringHelper.capitalizeFirstLetter(
            getProvinceName(property.location).replace('-', ' '),
        ),
        no_of_bathrooms: Number(property?.attributes?.bathrooms?.value),
        no_of_bedrooms: Number(property?.attributes?.bedrooms?.value),
        no_of_storeys:
            Number(
                property?.attributes?.floors?.value
                    ? property.attributes.floors.value
                    : '',
            ) || 1,
        price: property?.price?.offer.toString(),
        project_listing_id: property?.projectOriginId || parentId,
        property_condition:
            channel === 'new'
                ? SubChannelURLEnum.NewLaunch
                : SubChannelURLEnum.SubSale,
        property_type: formatListingType(type),
        srp_search_query: null,
        storey: type === 'apartemen' ? property?.attributes?.storey?.value : '',
        agent_agency_name: agencyName,
        agent_id: agentId,
        agent_name: agentName,
        project_id: property?.propertyPartner?.primaryProject?.originId,
        feature_listing_label: [
            ...new Set(
                (property?.additionalFlags || []).map(({ label }) => label)
            )
        ],
        developer_id:
            property?.propertyPartner?.agent?.originId ||
            property?.unregisterProject?.developerId,
    };

    return defaultTracker;
};

export default generatePayloadProperty;
